<template>
  <div style="width:100%;">
    <div class="styled-radio-container styled-radio-container--ou-donation row">
      <div class="radio-part">
  <input type="radio" name="paymentType" :checked="!['check', 'wire'].includes(form.gateway)" @click="(onSelect('Credit Card'), unsetCheck())" id="cc"> 
        <FormLabel class="radio-inline" for="cc">
          {{cc_text}}
        </FormLabel>
      </div>
      <div class="radio-part">
  <input type="radio" name="paymentType" id="check" :checked="form.gateway == 'check'" @click="onSelect(check_text || 'Check'); setCheck('check')"> 
        <FormLabel class="radio-inline" for="check">
          {{check_text}}
        </FormLabel>
      </div>
      <div class="radio-part" v-if="allowWire">
  <input type="radio" name="paymentType" id="wire" :checked="form.gateway == 'wire'" @click="onSelect(wire_text || 'Wire Transfer'); setCheck('wire')"> 
        <FormLabel class="radio-inline" for="wire">
          {{wire_text}}
        </FormLabel>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref } from 'vue';
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form';

export default defineComponent({
  props: {
    cc_text: {
      type: String,
      default: 'Pay by Credit Card',
    },
    check_text: {
      type: String,
      default: 'Pay by Credit Card'
    },
    wire_text: {
      type: String,
      default: 'Pay by Wire Transfer'
    },
    allowWire: Boolean
  },
  setup() {
    const { form, setValue } = usePaymentForm()

    const lastGateway = ref(form.value.gateway)

    return {
      form,
      onSelect(method: string) {
        try {
          window.ccOnPaymentMethod && window.ccOnPaymentMethod(method)
        } catch (e) {}
      },
      setCheck (type: 'check' | 'wire') {
        lastGateway.value = form.value.gateway
        setValue('gateway', type)
      },
      unsetCheck () {
        setValue('gateway', lastGateway.value)
      }
    }
  },
})
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 22%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 50%;
      margin-bottom: 10px;
    }
  }
  input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type='radio']:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
}
</style>